var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirthdayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6C10.11 6 11 5.1 11 4C11 3.62 10.9 3.27 10.71 2.97L9 0L7.29 2.97C7.1 3.27 7 3.62 7 4C7 5.1 7.9 6 9 6ZM15 9H10V7H8V9H3C1.34 9 0 10.34 0 12V21C0 21.55 0.45 22 1 22H17C17.55 22 18 21.55 18 21V12C18 10.34 16.66 9 15 9ZM16 20H2V17C2.9 16.99 3.76 16.63 4.4 15.99L5.49 14.92L6.56 15.99C7.87 17.3 10.15 17.29 11.45 15.99L12.53 14.92L13.6 15.99C14.24 16.63 15.1 16.99 16 17V20ZM16 15.5C15.49 15.49 15.01 15.3 14.65 14.93L12.52 12.8L10.38 14.93C9.64 15.67 8.35 15.67 7.61 14.93L5.48 12.8L3.34 14.93C2.99 15.29 2.51 15.49 2 15.5V12C2 11.45 2.45 11 3 11H15C15.55 11 16 11.45 16 12V15.5Z",
    fill: "#F9F9F9",
    fillOpacity: 0.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayIcon);
export default __webpack_public_path__ + "static/media/birthday_icon.9849ac4c5a907ede690493d920ffa170.svg";
export { ForwardRef as ReactComponent };